<div class="page">
  <div class="header">
    <button mat-icon-button (click)="cerrar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div>
      <h1>Agregar indicaciones</h1>
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="form" class="dialog-form">
      <mat-form-field appearance="outline">
        <mat-label>Nombre de la indicación </mat-label>
        <input matInput formControlName="indicacion" placeholder="Ej. Deshidratación" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Descripción</mat-label>
        <input
          matInput
          formControlName="descripcion"
          placeholder="Ej. Tomar 2 litros de agua durante al día"
        />
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button class="add-boton" mat-flat-button color="primary" type="button" (click)="guardar()">
      {{ data?.indicacion ? 'Guardar cambios' : 'Agregar' }}
      <mat-icon>add</mat-icon>
    </button>
  </mat-dialog-actions>
</div>
